import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getTVL } from "services";
import useVaultOverview from "./useVaultOverview";
import useYieldVaultData from "./useYieldVaultData";

const useTotalTVL = () => {
  const { data: tvlStats, isLoading } = useQuery({
    queryKey: ["tvlStats"],
    queryFn: async () => {
      const r = await getTVL();
      return r.data;
    },
  });

  const { isLoadingTotalStaked, totalStaked } = useVaultOverview();

  const {
    isLoadingTotalStaked: isLoadingYieldTotalStaked,
    totalStaked: yieldTotalStaked,
  } = useYieldVaultData();

  const gainTvl = useMemo(() => {
    let amount = 0;
    if (totalStaked) {
      amount += totalStaked;
    }
    if (yieldTotalStaked) {
      amount += yieldTotalStaked;
    }
    return amount;
  }, [totalStaked, yieldTotalStaked]);

  const stakedAmount = useMemo(() => {
    let amount = 0;
    if (tvlStats?.usdTvl) {
      amount += tvlStats.usdTvl;
    }
    if (gainTvl) {
      amount += gainTvl;
    }
    return amount;
  }, [tvlStats, gainTvl]);

  return {
    isLoadingTotalTvl:
      isLoadingYieldTotalStaked || isLoadingTotalStaked || isLoading,
    totalStaked: stakedAmount,
    restakeTvl: tvlStats?.usdTvl,
    gainTvl: gainTvl,
  };
};

export default useTotalTVL;
